import { useState } from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import debounce from 'debounce-promise';

import useApi from 'Lib/hooks/useApi';

import { getUnits } from '~/api/units';

const UnitSelect = props => {
    const [options, setOptions] = useState([]);

    const fetchUnits = useApi(getUnits);

    const loadOptions = search => {
        return new Promise(resolve => {
            fetchUnits({ search, includes: 'image,property' }).then(response => {
                const list = response.data.map(option => ({ label: option.unit.address, value: option.unit.address, obj: option }));

                setOptions(list);
                resolve(list);
            });
        });
    };

    const debouncedLoadOptions = debounce(loadOptions, 350, {
        leading: false
    });

    return (
        <AsyncCreatableSelect
            options={options}
            loadOptions={debouncedLoadOptions}
            value={{ label: props.value, value: props.value }}
            onChange={({ label, obj }) => {
                if (obj) {
                    const { unit = {}, property = {} } = obj;

                    props.form.setFieldValue('applyingFor', {
                        address: unit.address,
                        address2: unit.address2,
                        city: unit.city,
                        postalCode: unit.postalCode,
                        stateID: unit.stateID,
                        countryID: property.countryID
                    });
                    props.form.setFieldValue('unitID', unit.unitID);
                    props.handleChange({ value: unit.address, obj }, props.form, props.field);
                } else {
                    props.form.setFieldValue('applyingFor', {
                        address: label,
                        countryID: 'US'
                    });
                    props.handleChange({ value: label, obj }, props.form, props.field);
                }
            }}
            formatCreateLabel={input => `Enter address: "${input}"`}
            onBlur={props.onBlur}
        />
    );
};

export default UnitSelect;
